import { http } from '@/http/axios.js'

// 下单码物料详情
export function getConfigAPI() {
  return http({
    url: '/admin/oprt/preOrderQrCode/detail',
    method: 'get'
  })
}

// 保存物料码配置
export function saveConfigAPI(data) {
  return http({
    url: '/admin/oprt/preOrderQrCode/save',
    method: 'post',
    data
  })
}
